import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod/v3';

import { vendorLayoutRoute } from '../VendorLayout';

export const vendorDetailsRoute = createRoute({
  getParentRoute: () => vendorLayoutRoute,
  path: '/',
  component: lazyRouteComponent(() => import('./VendorDetailsView')),
  validateSearch: z.object({
    distributorsModalOpen: z.boolean().optional(),
    editModalOpen: z.boolean().optional(),
    venuesModalOpen: z.boolean().optional(),
  }),
});
